import { TableView } from "./table_view";
import { SeatEntityBase } from "../seat/seat_entity_base";
import { NetMsgTexasholdem } from "../../../../net/net_msg_data_map_texasholdem";
import { TableModelBase } from "./table_model_base";
import * as TexasProto from "../../../../net/proto/proto_texasholdem_game";
import { TableData } from "../../data/table_data";
import { SeatState, SeatConfig } from "../../component/seat_state_component";
import { PokerComponent } from "../../component/poker_component";
import { TableHelp } from "../../help/table_help";
import GameServer from "../../../../../hall/server/gameserver/game_server";
import ModuleManager from "../../../../../../framework/core/module_manager";
import { Define } from "../../data/const_define";
import ModelData, { IUserData } from "../../../../../public/model_data";
import { TexasRoom } from "../../../../net/proto/proto_texasholdem_room";
import CommonPokerComp from "../../component/common_poker_component";
import TexasSound from "../../../texas_sound";
import LanguageManager from "../../../../../../manager/language_manager";
import UserDataManager from "../../../../../../manager/user_manager";
import { joinUtil } from "../../../../../public/join_util";
import EventManager from "../../../../../../manager/event_manager";
import MVVMBase from "../../../../../../framework/core/mvvm/mvvm_base";
//基础数据交互层
export abstract class TableEntityBase extends cc.EventTarget {

    protected modeBase:TableModelBase;
    
    protected viewBase:TableView;
    //座位实体(下标即viewID)
    protected seatEntityBase:SeatEntityBase[];

    protected seatNode:cc.Node[];

    protected mvvBase:MVVMBase = null;

    //游戏状态对应的操作
    protected stateFunc:{[k:number]:Function} = {};

    //牌局数据
    get boardData(){
        return this.modeBase.boardData;
    }

    get settingData():TableData.Setting{
        return this.modeBase.settingData;
    }

    get commonData(){
        return this.modeBase.commonData;
    }

    //获取所有viewID的配置
    get seatInfo():SeatState[]
    {
        return this.viewBase.seatInfo;
    }

    get seatInfoPrefab():cc.Node{
        return this.viewBase.seatPlayerPrefab;
    }

    get commonPokers():CommonPokerComp{
        return this.viewBase.commonPokers;
    }

    //玩家扑克
    get playerHands():PokerComponent[]{
        return this.viewBase.twoHands;
    }

    get dealerNode():cc.Node{
        return this.viewBase.dealerNode;
    }

    get chatNode():cc.Node{
        return this.viewBase.chatNode;
    }

    //自己的座位 0是站起
    private _selfServerSeatID:number = 0;

    //维持座位不变的id
    private _baseSeatID:number = 6;

    get selfServerSeatID(){
        return this._selfServerSeatID;
    }

    set selfServerSeatID(v:number){
        this._selfServerSeatID = v;
        if (v == 0) {
            this.emit(Define.refreshUI,null);
        }else{
            this._baseSeatID = v;
        }
    }

    get seatData():TableData.SeatPlayerData[]{
        return this.modeBase.seatData;
    }

    getSeatData(playerid:number):TableData.SeatPlayerData{
        return this.findSeatInfo(playerid);
    }

    //牌桌座位数量
    protected tableSeatNumb:number = 0;

    create(){
        this.baseModelInstance();
        this.seatEntityBase = [];
        this.onCreate();
    }

    //model创建完成
    onCreate(){};

    initNetMessage(base:MVVMBase){
        this.modeBase.init(GameServer.instance.netClient)
        this.modeBase.clearMsgEvent();
        this.mvvBase = base;
        this.registerNetMessage();
    }

    createTableView(parent:cc.Node,tablePrefab:cc.Node){
        this.baseViewInstance(parent,tablePrefab);
        //创建玩家实体
        this.onViewInited();
    }

    protected setStateFunc(state:Define.NextAction,func:Function){
        this.stateFunc[state] = func.bind(this); 
    }

    //ui 创建完成
    onViewInited(){
        //创建 5张公共牌
        this.reset();
    };

    baseModelInstance(){
        if (!this.modeBase) {
            this.modeBase = new TableModelBase();
            this.modeBase.Init();
        }
    }

    baseViewInstance(parent:cc.Node,tablePrefab:cc.Node){
        let node = TableHelp.AddChild(tablePrefab,parent);
        if (!node) {
            cc.warn('创建牌桌失败prefab is null！');
            return;
        }
        if (!parent) {
            return;
        }
        if (!this.viewBase){
            this.viewBase = new TableView();
        }
        this.viewBase.Init(node);
    }
    
    //移动手牌
    movePokers(idx:number,toNode:cc.Node,comp?:Function){
        this.viewBase.pokersMove(idx,toNode,comp);
    }

    //获取座位实体
    getSeatEntity(viewID:number,func:Function){
        let seatEntity = this.seatEntityBase[viewID];
        if (seatEntity) {
            func(seatEntity);
        }
    }

    getEntityServerID(serverSeatID:number):SeatEntityBase{
        let seatEntity = this.seatEntityBase[this.getViewID(serverSeatID)];
        if (seatEntity) {
            return seatEntity;
        }
        return null;
    }

    getEntityByPlayerID(playerID):SeatEntityBase{
        for (let entity of this.seatEntityBase) {
            if (entity.playerID == playerID) {
                return entity;
            }
        }
        return null;
    }

    //根据服务器seatID获取viewID
    // server 1-9
    getViewID(serverSeatID:number):number{
        for (let i = 0; i < this.seatEntityBase.length; i++) {
            let entityBase = this.seatEntityBase[i];
            if (entityBase.serverSeatID == serverSeatID) {
                return i;
            }
        }
        return -1;
    }

    //根据viewID 获取serverID
    getSeatID(viewID:number):number{
        let seatEntity = this.seatEntityBase[viewID];
        if (seatEntity) {
            return seatEntity.serverSeatID;
        }
        return -1;
    }

    findSeatInfo(playerID:number):TableData.SeatPlayerData{
        return this.modeBase.findSeatInfo(playerID);
    }

    findSeatInfoBySeatID(seatID:number):TableData.SeatPlayerData{
        return this.modeBase.findSeatInfoBySeatID(seatID);
    }

    isRole(playerID:number){
        return playerID == ModelData.instance.roleData.id;
    }

    updateAddBet(isPlay:boolean){
        this.viewBase.updateBetAnim(isPlay);
    }

    getPlayerSeatData():TableData.SeatPlayerData{
        return this.findSeatInfoBySeatID(this.selfServerSeatID);
    }

    //我是否正在游戏中
    isSelfPlaying(){
        if (this.selfServerSeatID == 0) {
            return false;
        }else{
            let id = ModelData.instance.roleData.id;
            return this.isPlayerInGame(Number(id));
        }
    }

    isPlayerInGame(playerID:number){
        let data = this.findSeatInfo(playerID)
        if (data) {
             if(data.state == Define.PlayerState.Fighting){
                return true;
             }
        }
        return false;
    }

    //设置自动出牌
    setAutoSetting(auto:TableData.AutoSetting){
        if (this.settingData.autoCheck == TableData.AutoSetting.None) {
            this.settingData.autoCheck = auto;
        }else{
            if (this.settingData.autoCheck != auto) {
                this.settingData.autoCheck = auto;
            }else{
                this.settingData.autoCheck = TableData.AutoSetting.None;
            }
        }
    }

    //自己坐下的时候移动位置
    selfSeatDown(seatID:number){
        let viewID = this.getViewID(seatID);
        this.moveSeatAction(viewID);
    }

    selfSeatDownViewID(viewID:number){
        this.moveSeatAction(viewID);
    }

    private moveSeatAction(shift:number){
        if (shift == 0) {
            return;
        }

        for (let i = 0; i < this.tableSeatNumb; i++) {
            let pos = i;
            let next = (i+ this.tableSeatNumb -1) % this.tableSeatNumb;
            for (let j = 0; j < shift; j++) {
                pos = next;
                next = (next + this.tableSeatNumb -1) % this.tableSeatNumb;
            }

            let vc2 = this.seatInfo[pos].getPosition();
            
            //更新布局
            this.updateSeatToEndLayOut(i,pos);

            this.seatEntityBase[i].moveTo(vc2,0.3,()=>{
            });

            this.seatEntityBase[i].sortID = pos;
        }
        //排序
        this.seatEntityBase.sort(function(a:SeatEntityBase,b:SeatEntityBase){
            return a.sortID-b.sortID;
        })
    }

    protected playerSitDownSeatID(seatID:number){
        let viewID = this.getViewID(seatID);
        if (viewID != -1) {
            this.playerSitDown(viewID);
        }
    }

    //玩家坐下
    playerSitDown(viewID:number){
        this.updateSeatToEndLayOut(viewID,viewID);
        this.getSeatEntity(viewID,(e:SeatEntityBase)=>{
            e.playerSitDown();
        });
    }

    protected playerStandUpSeatID(seatID:number){
        let viewID = this.getViewID(seatID);
        if (viewID != -1) {
            this.playerStandUp(viewID);
        }
    }

    playerStandUp(viewID:number){
        this.updateSeatToEndLayOut(viewID,viewID);
        this.getSeatEntity(viewID,(e:SeatEntityBase)=>{
            e.playerStandUp();
        });
    }

    //更新座位位置
    protected updateSeatPos(viewID:number){
        let seatEntity = this.seatEntityBase[viewID];
        let pos = this.seatInfo[viewID].getPosition();
        seatEntity.stopAllActions();
        seatEntity.setPosition(pos);
        //更新布局
        this.updateSeatToEndLayOut(viewID,viewID);
    }

    //更新布局
    protected updateSeatToEndLayOut(curViewID:number,endViewID:number){
        let seatInfo = this.seatInfo[endViewID];
        let seatEntity = this.seatEntityBase[curViewID];
        if (seatInfo) {
            seatInfo.refreshNodeInfo((seatConfig:SeatConfig)=>{
                seatEntity.updateSeatInfo(seatConfig);
            })
        }
    }

    //玩家操作
    ReqPlayerOperator(ds:Define.Operator,mount:number = 0){
        let setting = this.settingData;
        mount = TableHelp.getRightMount(mount);
        if (setting.isMyRound) {//我方回合
            let seatData = this.getPlayerSeatData();

            let state = Define.TableSeatAction.None
            //是否可以让牌
            if (ds == Define.Operator.All_in) {//点击AllIn
                this.modeBase.send_playaction_request(Define.TableSeatAction.All_in);
                state = Define.TableSeatAction.All_in
                mount = seatData.chips;
            }else if (ds == Define.Operator.Raise) {//加注
                this.modeBase.send_playaction_request(Define.TableSeatAction.Raise,mount);
                state = Define.TableSeatAction.Raise
            }else if (ds == Define.Operator.GiveUp) {//弃牌
                this.modeBase.send_playaction_request(Define.TableSeatAction.Fold,mount);
                state = Define.TableSeatAction.Fold
            }else{
                let isCanCheck = setting.isOperator(Define.TableSeatAction.Check);
                if (isCanCheck) {
                    this.modeBase.send_playaction_request(Define.TableSeatAction.Check,mount);
                    state = Define.TableSeatAction.Check;
                }else{
                    let isCanCall = setting.isOperator(Define.TableSeatAction.Call);
                    if (isCanCall) {//跟
                        this.modeBase.send_playaction_request(Define.TableSeatAction.Call,mount);
                        state = Define.TableSeatAction.Call;
                        mount = this.settingData.mount;
                    }
                }
            }
            if (seatData) {
                // let entity = this.getEntityByPlayerID(seatData.player_id);
                // if (entity) {
                //     cc.log('------previousSeatAction>>>>',mount);
                //     let bet = seatData.bet + mount;
                //     let chips = seatData.chips - mount;
                //     //更新玩家状态
                //     let data = {
                //         decision:state,
                //     }
                //     entity.previousSeatAction(data);
                //     let noShowBet = (state == Define.TableSeatAction.Fold
                //                     || state == Define.TableSeatAction.Check
                //                     || state == Define.TableSeatAction.None);
                //     cc.log('------>>>',bet,noShowBet)
                //     if (bet > 0 && (!noShowBet)) {
                //         entity.updateTableBet(bet,true);
                //     }
                //     entity.updateChips(chips);
                //     this.commonData.isNeedAnim = false;//无需动画
                // }
            }
            //获取我方数据
            this.emit(Define.refreshUI,null);
        }
    }

    //直接处理action 然后服务器返回进行验证
    operatorAction(ds:Define.Operator,mount?:number){
        let setting = this.settingData;
        if (setting.isMyRound) {//是否是我方回合
            //直接操作金额
            this.emit(Define.refreshUI,null);
        }
    }

    ReqPlayerAction(type:Define.SeatAction,seatID?:number,coin?:number,isAutoCharge?:boolean){
        if (seatID == undefined) {
            seatID = this.selfServerSeatID;
        }
        this.modeBase.send_seatAction_request(type,seatID,coin,isAutoCharge);
    }

    //补充筹码
    ReqRecharge(coin:number,charge:boolean){
        this.modeBase.send_ReCharge_request(coin,charge);
    }

    //注册网络监听
    private registerNetMessage(){
        //网络事件订阅
        let self = this;
        //登陆或者重连游戏发送
        self.modeBase.subscibeMsgEvent<TexasProto.Texas.GameInfo>(NetMsgTexasholdem.GameInfo,function(protoData){
            self.loginTexasholdemGame(protoData);
        },true);

        //玩家操作结果,只有失败才会回复
        self.modeBase.subscibeMsgEvent<TexasProto.Texas.ActionReply>(NetMsgTexasholdem.PlayerAction,function(protoData){
            self.playActionResult(protoData);
        },true);

        //广播玩家动作，广播动作包括自己
        self.modeBase.subscibeMsgEvent<TexasProto.Texas.ActionBroadcast>(NetMsgTexasholdem.ActionBroadcast,function(protoData){
            self.actionBroadCast(protoData);
        },true)

        //座位相关，只有失败才有回复
        self.modeBase.subscibeMsgEvent<TexasProto.Texas.SeatActionReply>(NetMsgTexasholdem.SeatAction,function(protoData){
            self.seatActionChange(protoData);
        },true)

        //座位广播动作，包括自己
        self.modeBase.subscibeMsgEvent<TexasProto.Texas.SeatActionBroadcast>(NetMsgTexasholdem.SeatActionBroadcast,function(protoData){
            self.seatActionChangeBroadCast(protoData);
        },true)

        //游戏结算消息
        self.modeBase.subscibeMsgEvent<TexasProto.Texas.GameSettlement>(NetMsgTexasholdem.GameSettlement,function(protoData){
            self.gameSettlement(protoData);
        },true)

        self.modeBase.subscibeMsgEvent<TexasRoom.EnterBroadcast>(NetMsgTexasholdem.EnterBroadcast, function (protoData) {
            self.onNetMsgEnterNotify(protoData)
        },true)

        self.modeBase.subscibeMsgEvent<TexasProto.Texas.IRechargeReply>(NetMsgTexasholdem.Recharge, function (protoData) {
            self.oRechargeReply(protoData)
        },true)

        self.modeBase.subscibeMsgEvent<TexasProto.Texas.Error>(NetMsgTexasholdem.Error, function (protoData) {
            let code = protoData.error.toString();
            ModuleManager.instance.toastKey('server_error_' + code);
        },true)

        self.modeBase.subscibeMsgEvent<TexasProto.Texas.NextAction>(NetMsgTexasholdem.NextAction, function (protoData) {
            self.onNextActionData(protoData);
        },true)

        self.modeBase.subscibeMsgEvent<TexasProto.Texas.NeedRecharge>(NetMsgTexasholdem.NeedRecharge, function (protoData) {
            self.showAddBetWindow();
        },true)

        self.modeBase.subscibeMsgEvent<TexasProto.Texas.GameStart>(NetMsgTexasholdem.GameStart, function (protoData) {
            self.showTime(protoData);
        },true)

        self.modeBase.subscibeMsgEvent<TexasProto.Texas.CoinStatus>(NetMsgTexasholdem.CoinStatus, function (protoData) {
            self.coinStatus(protoData);
        },true)

        self.modeBase.subscibeMsgEvent<TexasProto.Texas.UserMsg>(NetMsgTexasholdem.UserMsg, function (protoData) {
            self.userMsg(protoData);
        },true)

        self.modeBase.subscibeMsgEvent<TexasRoom.LeaveBroadcast>(NetMsgTexasholdem.LeaveBroadcast, function (protoData) {
            self.leaveBroadcast(protoData);
        },true)

        self.modeBase.subscibeMsgEvent<TexasRoom.KickPlayerBroadcast>(NetMsgTexasholdem.KickPlayerBroadcast, function (protoData) {
            self.kickPlayerBroadcast(protoData);
        },true)

        
    }

    //-----------------网络事件
    //登陆游戏,或者重连游戏,下一句的开始
    loginTexasholdemGame(protoData:TexasProto.Texas.GameInfo){
        this.modeBase.boardData = this.modeBase.boardData || new TableData.BoardData();
        this.modeBase.boardData.cards = protoData.publicCards;
        this.modeBase.boardData.baseBet = protoData.baseBet;
        this.modeBase.boardData.banker = protoData.banker;
        this.modeBase.boardData.pot = protoData.pot;
        this.modeBase.boardData.bigBlind = protoData.bigBet / 100;//大盲注
        this.modeBase.boardData.sitRole = [];//清空当前座位玩家状态
        //公共数据
        this.modeBase.commonData = this.modeBase.commonData || new TableData.commonData();
        this.modeBase.commonData.maxBet = 0;
        this.modeBase.commonData.sidePotIndex = 0;
        this.modeBase.commonData.coinStatus = protoData.coinStatus;//默认解锁
        this.modeBase.commonData.max_join_coin = protoData.maxJoinCoin || 0;
        this.modeBase.commonData.min_join_coin = protoData.minJoinCoin || 0;
        this.modeBase.commonData.minJoinPeople = protoData.minPlayerCount;
        this.modeBase.commonData.isShowHand = true;
        this.modeBase.commonData.isNeedAnim = true;
        this.modeBase.commonData.isSettle = false;
        this.onRevGameInfo(protoData);
    };
    //玩家操作结果
    playActionResult(protoData:TexasProto.Texas.ActionReply){
        ModuleManager.instance.toastKey('server_error_' + protoData.errorCode);
        if (this.isSelfPlaying()) {
            if (!protoData.ok) {
                this.settingData.isMyRound = true//设置位我方操作
                this.emit(Define.refreshUI,this.settingData);
                //返回代码
                if (protoData.action != undefined) {
                    // let seatData = this.getPlayerSeatData();
                    // if (seatData) {
                    //     let entity = this.getEntityByPlayerID(seatData.player_id);
                    //     if (entity) {
                    //         //更新玩家状态
                    //         entity.previousSeatAction(protoData.action);
                    //     }
                    // }
                }

            }
        }
    };

    userMsg(protoData:TexasProto.Texas.UserMsg){
        let seatData = this.findSeatInfoBySeatID(protoData.playerPos);
        if (seatData) {
            seatData.balance = protoData.balance;//账户余额
            if (protoData.playerPos == this.selfServerSeatID) {//自己余额变动
                if (this.commonData) {
                    this.commonData.accountbalance = protoData.balance;
                }
                UserDataManager.balanceChangeMessage(protoData.balance)
            }

            this.setUserGameTableCurrency(seatData.player_id,protoData.balance);
        }
    }

    coinStatus(protoData:TexasProto.Texas.ICoinStatus){
        this.commonData.coinStatus = protoData.status;
    }

    //玩家广播动作
    actionBroadCast(protoData:TexasProto.Texas.ActionBroadcast){
        this.onActionBroadCast(protoData);
    }

    onNetMsgEnterNotify(protoData:TexasRoom.EnterBroadcast){
        //玩家进入
        let posInfo=protoData.posInfo;
        let data = this.findSeatInfo(posInfo.playerId)//我还正在游戏中
        let seatData = new TableData.SeatPlayerData();
        seatData.player_id = posInfo.playerId;
        seatData.player_pos = posInfo.posIndex;
        seatData.playerName = this.setPlayerData(posInfo.playerInfo,posInfo.playerId);
        seatData.chips = posInfo.coinBalance;//携带的金币数量
        seatData.state = Define.PlayerState.Look_2;
        seatData.betState = 0;
        let isRole = this.isRole(posInfo.playerId);
        let isCacheData = (data != null) && this.isInToCheckState();
        if (isCacheData && !isRole) {//该座位有虚拟玩家
            this.sitRoleChange(posInfo.posIndex,Define.SitState.enterRoom,seatData);//暂时保存
        }else{
            this.modeBase.pushSeatInfo(seatData);
            let entity = this.getEntityServerID(posInfo.posIndex)
            if (entity) {
                entity.reset();
                entity.seatData = seatData;
            }
            this.playerSitDownSeatID(seatData.player_pos);
            this.playerEnterRoom();
        }

        this.setUserGameTableCurrency(seatData.player_id,seatData.chips)
    }

    setPlayerData(str:string,playid:number):string{
        UserDataManager.setUserJsonData(str);
        let userdata : IUserData = UserDataManager._userDatas[playid.toString()]
        if (userdata) {
            return userdata.name;
        }
        return '';
    }

    setUserGameTableCurrency(playerid:number,gold:number){
        let data = this.getSeatData(playerid);
        if (data) {
            if (data.state == Define.PlayerState.GiveUp
                || data.state == Define.PlayerState.Look_2) {//弃牌
                UserDataManager.setUserGameTableCurrency(playerid,0)
                return;
            }
        }
        if (this.commonData.coinStatus == 2) {//解锁玩家
            UserDataManager.setUserGameTableCurrency(playerid,0)
        }else if (this.commonData.coinStatus == 1) {//锁定玩家
            UserDataManager.setUserGameTableCurrency(playerid,gold)
        }
    }

    showTime(protoData:TexasProto.Texas.GameStart){

    }

    //座位更改
    seatActionChange(protoData:TexasProto.Texas.SeatActionReply){
        if (protoData.ok) {
            if (protoData.type == Define.SeatAction.Leave) {
                this.exitTable();
            }
        }else{
            ModuleManager.instance.toastKey('server_error_' + protoData.errorCode);
        }
    }

    //座位更改广播
    seatActionChangeBroadCast(protoData:TexasProto.Texas.SeatActionBroadcast){
        //站起的玩家
        this.commonData.isSettle = protoData.isSettle;

        for (let seat of protoData.seats) {
            let isRole = this.isRole(seat.playerId);
            if (seat.type == Define.SeatAction.Stand) {
                if (isRole) {
                    this.selfServerSeatID = 0;
                }else{
                    let player = this.findSeatInfo(seat.playerId);
                    if (!player) {
                        continue;
                    }
                    let isInGame = this.isInGame(player.state);
                    if (this.isInToCheckState() && isInGame) {//已经进入下注状态
                        player.state = Define.PlayerState.GiveUp;
                        this.playerStandOrLeave(seat.playerId);
                        this.sitRoleChange(seat.seat,Define.SitState.Stand,seat.playerId);
                    }
                }
            }else if(seat.type == Define.SeatAction.Seat){
                //判断该位置是否是空位
                let seatData = this.findSeatInfo(seat.playerId);//我还正在游戏中

                let data = new TableData.SeatPlayerData();
                data.player_id = seat.playerId;
                data.player_pos = seat.seat;
                data.state = Define.PlayerState.Look_2;
                data.playerName = this.setPlayerData(seat.playerInfo,seat.playerId);
                if (seat.recharge != undefined) {
                    data.chips = seat.recharge.coin;//携带的金币数量
                }

                let isCacheData = (seatData != null) && this.isInToCheckState();
                if (isCacheData && !isRole) {//该座位有虚拟玩家,则缓存下来
                    this.sitRoleChange(seat.seat,Define.SitState.SitDown,data);//暂时保存
                }else{
                    this.modeBase.pushSeatInfo(data);
                    let entity = this.getEntityServerID(data.player_pos)
                    if (entity) {
                        entity.reset();
                        entity.seatData = data;
                        TexasSound.playSeat()
                        this.playerSitDownSeatID(data.player_pos)
                    }
                }
            }else if (seat.type == Define.SeatAction.Remain) {//余额变动
                
            }else if (seat.type == Define.SeatAction.Leave) {//离开牌桌
                if (isRole) {//玩家离开
                    this.leaveTable(seat.playerId);
                }else{
                    let seatData = this.findSeatInfo(seat.playerId);
                    if (!seatData) {
                        continue;
                    }
                    let isInGame = this.isInGame(seatData.state);
                    if (this.isInToCheckState() && isInGame) {
                        seatData.state = Define.PlayerState.GiveUp
                        this.playerStandOrLeave(seat.playerId);
                        this.sitRoleChange(seatData.player_pos,Define.SitState.Leave,seat.playerId);
                    }else{
                        this.leaveTable(seat.playerId);
                    }
                }
            }
        }

        // for (let id of protoData.playerId) {
        //     let isRole = this.isRole(id);
        //     if (protoData.action.type == Define.SeatAction.Stand) {
        //         if (isRole) {
        //             this.selfServerSeatID = 0;
        //         }else{
        //             let player = this.findSeatInfo(id);
        //             let isInGame = this.isInGame(player.state);
        //             if (this.isInToCheckState() && isInGame) {//已经进入下注状态
        //                 player.state = Define.PlayerState.GiveUp;
        //                 this.playerStandOrLeave(id);
        //                 this.sitRoleChange(protoData.action.seat,Define.SitState.Stand,id);
        //             }
        //         }
        //     }else if(protoData.action.type == Define.SeatAction.Seat){
        //         //判断该位置是否是空位
        //         let seatData = this.findSeatInfo(id);;//我还正在游戏中

        //         let data = new TableData.SeatPlayerData();
        //         data.player_id = id;
        //         data.player_pos = protoData.action.seat;
        //         data.state = Define.PlayerState.Look_2;
        //         data.playerName = this.setPlayerData(protoData.playerInfo,id);
        //         if (protoData.action.recharge != undefined) {
        //             data.chips = protoData.action.recharge.coin;//携带的金币数量
        //         }

        //         let isCacheData = (seatData != null) && this.isInToCheckState();
        //         if (isCacheData && !isRole) {//该座位有虚拟玩家,则缓存下来
        //             this.sitRoleChange(protoData.action.seat,Define.SitState.SitDown,data);//暂时保存
        //         }else{
        //             this.modeBase.pushSeatInfo(data);
        //             let entity = this.getEntityServerID(data.player_pos)
        //             if (entity) {
        //                 entity.reset();
        //                 entity.seatData = data;
        //                 TexasSound.playSeat()
        //                 this.playerSitDownSeatID(data.player_pos)
        //             }
        //         }
        //     }else if (protoData.action.type == Define.SeatAction.Leave) {//离开牌桌
        //         if (isRole) {//玩家离开
        //             this.leaveTable(id);
        //         }else{
        //             let seatData = this.findSeatInfo(id);
        //             let isInGame = this.isInGame(seatData.state);
        //             if (this.isInToCheckState() && isInGame) {
        //                 seatData.state = Define.PlayerState.GiveUp
        //                 this.playerStandOrLeave(id);
        //                 this.sitRoleChange(seatData.player_pos,Define.SitState.Leave,id);
        //             }else{
        //                 this.leaveTable(id);
        //             }
        //         }
        //     }else if (protoData.action.type == Define.SeatAction.Change) {//换位置
                
        //     }
        
    }

    private playerStandOrLeave(id:number){
        let entity = this.getEntityByPlayerID(id);
        if (entity) {
            let data = entity.seatData;
            if (data) {
                data.state = Define.PlayerState.GiveUp;
                entity.setPlayerState();
                entity.throwCard()
            }
        }
    }
    
    getSitRole(playerPos:number):TableData.ISitData{
        let data = null;
        for (let i = 0; i < this.boardData.sitRole.length; i++) {
            let v = this.boardData.sitRole[i];
            if (v.playerPos == playerPos) {//更新座位数据
                data = v;
                break;
            }
            
        }
        return data;
    }

    private sitRoleChange(pos:number,state:Define.SitState,extenData?:any){
        let roleSitData = this.getSitRole(pos);
        if (roleSitData) {
            roleSitData.state = state;
            roleSitData.data = extenData;
        }else{
            let data = {
                playerPos:pos,
                state:state,
                data:extenData,
            }
            this.boardData.sitRole.push(data);
        }
    }

    //是否在游戏中
    isInGame(state:Define.PlayerState){
        if (state == Define.PlayerState.Look_2
            || state == Define.PlayerState.Look_1) {
            return false;
        }
        return true;
    }

    //游戏是否已经进入下注状态了
    isInToCheckState(){
        let state = this.boardData.gameState;
        if (state == Define.NextAction.No_opening) {
            return false;
        }
        return true;
    }

    //离开游戏
    leaveGame(){
    }

    //游戏结算
    gameSettlement(protoData:TexasProto.Texas.GameSettlement){

    }

    onRevGameInfo(protoData:TexasProto.Texas.GameInfo){
        //重置牌桌
        this.reset();

        this.initGame(protoData);

        this.selfServerSeatID = protoData.selfPos || 0;
        if (this.selfServerSeatID == 0) {
            this.seatEntityBase[0].serverSeatID = this._baseSeatID || 3;//默认座六号位置
        }else{
            this.seatEntityBase[0].serverSeatID = this.selfServerSeatID;
        }
        this.updateSeatPos(0)
        
        //其他座位基础设置
        for (let i = 1; i < this.tableSeatNumb; i++) {
            let seatEntity = this.seatEntityBase[i];
            seatEntity.serverSeatID = this.seatEntityBase[i-1].serverSeatID % this.tableSeatNumb + 1;
            this.updateSeatPos(i);
        }
    
        this.modeBase.seatData = [];

        if (protoData.nextAction) {
            this.boardData.gameState = protoData.nextAction.state;
        }
        
        for (let player of protoData.players) {
            let data = new TableData.SeatPlayerData();
            data.player_id = player.playerId;
            data.player_pos = player.playerPos;
            if (this.boardData.gameState == Define.NextAction.No_opening) {
                data.state = Define.PlayerState.Look_2;
            }else{
                data.state = player.state;
            }
            data.chips = player.chips;
            data.bet = player.curRoundBet;
            if (this.commonData.maxBet <= data.bet) {
                this.commonData.maxBet = data.bet;
            }
            data.playerName = this.setPlayerData(player.playerInfo,player.playerId);
            data.cards = player.cards.concat([]);
            data.obtainBet = 0;
            data.callBet = 0;
            data.betState = player.betStatus;
            if (player.maxCardInfo) {
                data.cardType = player.maxCardInfo.maxCardsType;
            }else{
                data.cardType = 0;
            }
            this.modeBase.seatData.push(data);
            this.getEntityServerID(data.player_pos).seatData = data;

            this.setUserGameTableCurrency(data.player_id,data.chips)
        }

        if (protoData.nextAction != undefined) {
            this.doRevNextActionData(protoData.nextAction);
        }

        //操作设置数据
        if (!this.modeBase.settingData) {
            this.modeBase.settingData = new TableData.Setting();
        }
        this.modeBase.settingData.reset();
        this.emit(Define.updateUI,protoData.roundNo);

        EventManager.instance.dispatch('Game_Table_Start');
    }

    //游戏初始化执行
    protected initGame(protoData){
        this.tableSeatNumb = protoData.maxPlayerCount;
    }

    playerEnterRoom(){

    }

    oRechargeReply(data:TexasProto.Texas.IRechargeReply){
        let seatData = this.getPlayerSeatData();
        if (seatData) {
            if (data.ok) {
                let coin = TableHelp.getRightMount(data.recharge.coin);
                let gameCoin = TableHelp.addThousands(coin);
                if (!data.isPlaying) {
                    seatData.chips = data.recharge.coin;
                    //ModuleManager.instance.toast(LanguageManager.t(Define.OpTips[10]) + gameCoin);
                }else{
                    ModuleManager.instance.toastKey('jd_info_next_update');
                }
            }
        }
        if (!data.ok) {
            if (data.errorCode == 1) {

            }else{
                ModuleManager.instance.toastKey(Define.OpTips[8]);
            }
        }
    }
    
    onActionBroadCast(protoData:TexasProto.Texas.ActionBroadcast){
        //数据更改
        let data = this.findSeatInfoBySeatID(protoData.playerPos);
        
        if (protoData.currentAction.decision == Define.TableSeatAction.Raise
            || protoData.currentAction.decision == Define.TableSeatAction.Call
            || protoData.currentAction.decision == Define.TableSeatAction.All_in) {
            if (data) {
                data.bet += TableHelp.getRightMount(protoData.currentAction.mount);  
                if (this.commonData.maxBet <= data.bet) {
                    this.commonData.maxBet = data.bet;
                }

                if (protoData.currentAction.decision == Define.TableSeatAction.All_in) {
                    if (this.selfServerSeatID != 0
                        && this.selfServerSeatID == protoData.playerPos) {
                            this.emit(Define.refreshUI,null);
                    }
                    data.state = Define.PlayerState.All_in
                    data.chips = 0;
                }
            }
        }else if (protoData.currentAction.decision == Define.TableSeatAction.Fold) {
            if (data) {
                data.state = Define.PlayerState.GiveUp;
                data.bet = 0;//弃牌
            }
        }
        if (protoData.pot != undefined && protoData.pot > 0) {
            this.boardData.pot = TableHelp.getRightMount(protoData.pot);
        }
        if (protoData.chips != undefined) {
            this.setUserGameTableCurrency(data.player_id,protoData.chips)
            data.chips = TableHelp.getRightMount(protoData.chips);
        }

        this.doRevNextActionData(protoData.nextAction);
    }

    //更新下注
    protected resetMount(){
        this.seatData.forEach((data:TableData.SeatPlayerData)=>{
            if (data) {
                data.bet = 0;
            }
        })
        this.commonData.maxBet = 0;
    }

    doRevNextActionData(action:TexasProto.Texas.INextAction){
        if (action != undefined) {
            let state = action.state;
            this.boardData.gameState = state;
            if (state == Define.NextAction.CommonCard 
                || state == Define.NextAction.CommonCard_End) {
                    this.boardData.cards = action.publicCards;
                } 

            if (state == Define.NextAction.End
                || state == Define.NextAction.CommonCard_End
                || state == Define.NextAction.sidePotEnd ) {
                    this.doGameSettlement(action.gameSettlement);
            }

            if (state == Define.NextAction.Player_Actions) {
                let playAction = action.playerAction;
                if (playAction != undefined) {
                    let data = this.findSeatInfo(playAction.playerId);
                    data.callBet = TableHelp.getRightMount(playAction.callBet);
                }
            }
        }
    }

    //nextAction处理
    onNextActionData(action:TexasProto.Texas.INextAction){
        this.doRevNextActionData(action)
    }

    showAddBetWindow(){

    }

    kickPlayerBroadcast(proto:TexasRoom.KickPlayerBroadcast){
        if (this.isRole(proto.playerId)) {
            if(!joinUtil.checkLeave(proto.reason,this.mvvBase)){
                ModuleManager.instance.toastKey('server_error_' + proto.reason);
                this.exitTable();
            }
        }else{

            let seatData = this.findSeatInfo(proto.playerId);
            if (!seatData) {
                return;
            }
            let isInGame = this.isInGame(seatData.state);
            if (this.isInToCheckState() && isInGame) {
                seatData.state = Define.PlayerState.GiveUp
                this.playerStandOrLeave(proto.playerId);
                this.sitRoleChange(seatData.player_pos,Define.SitState.Leave,proto.playerId);
            }else{
                this.leaveTable(proto.playerId);
            }
        }
    }

    leaveBroadcast(proto:TexasRoom.LeaveBroadcast){
        if (this.isRole(proto.playerId)) {
            if(!joinUtil.checkLeave(proto.reason,this.modeBase.module)){
                ModuleManager.instance.toastKey('server_error_' + proto.reason);
                this.exitTable();
            }
        }
    }

    private doGameSettlement(proto:TexasProto.Texas.IGameSettlement){
        if (proto == undefined) {
            cc.error('没有结算数据!');
            return 
        }
        this.boardData.gameState = Define.NextAction.End;
        for (let player of proto.players) {
            let data = this.findSeatInfo(player.playerId)
            if (data) {
                data.win_lose_bet = TableHelp.getRightMount(player.winLoseBet);//本局的输赢
                data.cards = player.cards;//结算赋值
            }
        }
    }

    showTwoHands(cards:number[]){
        this.viewBase.showTwoHands(cards);
    }

    showTwoHandsOnly(){
        this.viewBase.showShowPokerOnly();
    }

    showCardsType(typeID:number){
        cc.log('-->>>showCardsType');
        typeID = typeID == undefined ? 0 : typeID;
        this.viewBase.showCardsType(typeID);
    }

    showTypeNode(isShow:boolean){
        this.viewBase.myTypeNode.active = isShow;
    }

    //是否显示玩家手牌
    showPlayerCard(ishide:boolean){
        this.viewBase.isHideMyCards(ishide);
    }

    setHandState(isShow:boolean){
        this.viewBase.setHandState(isShow);
    }

    resumeHands(){
        this.viewBase.resumeHands();
        this.viewBase.setPatternMask(false);
    }

    maskHands(){
        this.viewBase.maskMyCards();
        this.viewBase.setPatternMask(true);
    }

    //游戏中的entity 是否排序 第一个是我放，然后依次执行
    inGameSeatEntity(isSort?:boolean):SeatEntityBase[]{
        let seatEntity:SeatEntityBase[] = [];
        for (let se of this.seatEntityBase) {
            if (se.isPlayingGame()) {
                seatEntity.push(se);
            }
        }
        //根据serverID排序
        seatEntity.sort(function(a:SeatEntityBase,b:SeatEntityBase){
            return a.serverSeatID-b.serverSeatID;
        })

        //起始为庄家
        if (isSort) {
            let sortEntity = [];
            let otherEntity = [];
            let insert = false;
            for (let seat of seatEntity) {
                if (seat.seatData) {
                    let isBank = seat.seatData.player_pos == this.boardData.banker//找到庄家
                    if (isBank) {
                        sortEntity.push(seat);
                        insert = true;
                    }else{
                        if (insert) {
                            sortEntity.push(seat);
                        }else{
                            otherEntity.push(seat);
                        }
                    }
                }
            }
            seatEntity.length = 0;
            seatEntity = sortEntity.concat(otherEntity);
        }
        return seatEntity;
    }
    throwCardsAction(){

    }
    
    dealCardsAction(){}
    ttt(id:number){
        for (let entity of this.seatEntityBase) {
            entity.setActiveInfo(true);
            entity.showBet(222);
            entity.setBetState(true);
            entity.setOpTime(10);
            entity.setSmallCard(true);
        }
    }

    gggg(){
        for (let entity of this.seatEntityBase) {
            entity.setActiveInfo(true);
            entity.showBet(222);
            entity.setBetState(true);
            entity.setOpTime(10);
            entity.setSmallCard(true);
        }
        // for (let entity of this.seatEntityBase) {
        //     entity.guiChi(this.viewBase.dealerNode);
        //     entity.setOperatorDes('operator_big',Define.OperatorType.Image_Op)
        // }

        // this.commonPokers.recycleAll();

        // this.commonPokers.enQueue([23,21,21],()=>{
        //     cc.log('---->>>>执行完成')
        //     // for (let entity of this.seatEntityBase) {
        //     //     entity.setOperatorDes('operator_big',Define.OperatorType.Name_Op)
        //     // }
        //     //this.updateMyMaxCardType(action.maxCardInfo);//更新我方最大牌型
        // });
    }

    ww(){
        //this.commonPokers.recycleAll();


        let entity = this.getEntityServerID(this.selfServerSeatID);
        if (entity) {
            entity.showEndHands([21,24],1);
        }

    }

    //重置牌桌
    reset(){
        this.commonPokers.recycleAll();
        this.setHandState(false);
    }

    //离开牌桌
    leaveTable(playerID:number){
        if (!this.isRole(playerID)) {
            let entity = this.getEntityByPlayerID(playerID);
            if (entity) {
                entity.seatData = null;
            }
            this.modeBase.removeSeatInfo(playerID);
        }
    };

    //退出牌桌
    exitTable(){

    }

    clear(){
        
    }
}
